/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-await-in-loop */
/* eslint-disable sonarjs/cognitive-complexity */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Col, Button, Row } from "react-bootstrap";
import InputMask from "react-input-mask";
import IModalProps from "../../../model/ModalProps";
import {
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../../../api/ApiClient";
import SelectOption from "../../../model/SelectOption";
import GenericUtils from "../../../utils/GenericUtils";
import InputText from "../../../components/InputText";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import { StyledFormCheck } from "../../../styles/MainStyles";
import { StyledDefaultButtonLink } from "../../../components/ButtonsComponents";
import { ReactComponent as UserIcon } from "../../../assets/icons/User.svg";
import ModalProfessores from "./ModalProfessores";
import CircleXMark from "../../../assets/icons/CircleXMark.svg";
import { AutocompleteCombo } from "../../../components/Autocomplete";
import View from "../../../assets/icons/View.svg";
import DialogMessage from "../../../components/DialogMessage";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

interface IProfessores {
    docenteId: string;
    matriculaAdp: string;
    nome: string;
    email: string;
    isSelecionado: boolean;
}

interface ICrs {
    cr: any[];
    professores: IProfessores[];
    isAll: boolean;
}

interface IModalAbonoLoteProps extends IModalProps {
    open: boolean;
    setOpenDialogQuestion: (value: boolean) => void;
    context?: string;
    abonoEdit?: any;
    onSuccess: (e: any) => void;
}

const ModalAbonoLoteContent: React.FC<IModalAbonoLoteProps> = ({
    open,
    setOpenDialogQuestion,
    context,
    abonoEdit,
    onSuccess,
}) => {
    const [nomeFeriado, setNomeFeriado] = useState(
        "Abono realizado pela administração"
    );
    const [campus, setCampus] = useState<any[]>([]);
    const [horaI, setHoraI] = useState("");
    const [horaF, setHoraF] = useState("");
    const [isDia, setIsDia] = useState(false);
    const [modalProf, setModalProf] = useState(false);
    const [crSelect, setCrSelect] = useState<ICrs[]>([]);
    const [crEdit, setCrEdit] = useState<ICrs | undefined>(undefined);
    const [crEditIndex, setCrEditIndex] = useState<number>(-1);
    const [errorMessage, setErrorMessage] = useState("");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [crEditList, setCrEditList] = useState<any[]>([]);

    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();
    const acessTokenDocente = GenericUtils.getAccessTokenDocente();

    const [campusAutoCompleteList, setCampusAutoCompleteList] = useState<
        SelectOption[]
    >([]);

    async function getCR(value: string) {
        const newCRs: any = [];
        const response = await axiosGetRequest(
            `/docente/v1/centroresultados?campusId=${value}&_limit=999999`,
            acessTokenDocente,
            instance
        );

        if (response.data.centroResultados) {
            response.data.centroResultados.forEach((centroDeResultados: any) =>
                newCRs.push({
                    value: centroDeResultados.id,
                    label: centroDeResultados.nome,
                })
            );

            setCrEditList(newCRs);
        }
        return newCRs;
    }

    async function getProfessores(crId: number, docentes: any[]) {
        const newProfs: IProfessores[] = [];
        const response = await axiosGetRequest(
            `/docente/v1/docentes?centroResultadoId=${crId}`,
            acessTokenDocente,
            instance
        );

        if (response.data.docentes) {
            response.data.docentes.forEach(async (docente: any) => {
                const sel =
                    (await docentes.find(
                        (i) => Number(i.id) === docente.docenteId
                    )?.id) > 0;
                newProfs.push({
                    docenteId: docente.docenteId,
                    matriculaAdp: docente.matriculaAdp,
                    nome: docente.nome,
                    email: docente.email,
                    isSelecionado: sel,
                });
            });
        }

        return newProfs;
    }

    const handleCloseDialogError = () => {
        setErrorMessage("");
    };

    const DialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const getCampus = async () => {
        const newCampus: SelectOption[] = [];

        const response = await axiosGetRequest(
            `/docente/v1/centros-resultado/campi`,
            acessToken,
            instance
        );

        response.data.map((actualCampus: any) =>
            newCampus.push({
                value: actualCampus,
                label: actualCampus,
            })
        );

        setCampusAutoCompleteList(newCampus);
    };

    const handleChangeCampus = (e: any) => {
        setCampus(e);
    };

    useEffect(() => {
        if (open) {
            getCampus();
        } else {
            setHoraI("");
            setHoraF("");
            setIsDia(false);
            setCampus([]);
            setNomeFeriado("Abono realizado pela administração");
            setCrSelect([]);
            setCrEdit(undefined);
            setCrEditIndex(-1);
        }
    }, [open]);

    useEffect(() => {
        async function init() {
            if (abonoEdit) {
                setNomeFeriado(abonoEdit.nome);
                setHoraI(abonoEdit.horaInicio);
                setHoraF(abonoEdit.horaFim);
                setIsDia(abonoEdit.diaInteiro);
                setCampus([
                    {
                        value: abonoEdit.campus.id,
                        label: abonoEdit.campus.id,
                    },
                ]);
                const crs = await getCR(abonoEdit.campus.id);
                const temp: ICrs[] = [];
                for (let i = 0; i < abonoEdit.centroResultados.length; i++) {
                    temp.push({
                        cr: [
                            {
                                value: crs.find(
                                    (e: any) =>
                                        e.value ===
                                        abonoEdit.centroResultados[i]
                                            .centroResultado.id
                                ).value,
                                label: crs.find(
                                    (e: any) =>
                                        e.value ===
                                        abonoEdit.centroResultados[i]
                                            .centroResultado.id
                                ).label,
                            },
                        ],
                        isAll: abonoEdit.centroResultados[i].todoProfessor,
                        professores: abonoEdit.centroResultados[i].todoProfessor
                            ? []
                            : await getProfessores(
                                  abonoEdit.centroResultados[i].centroResultado
                                      .id,
                                  abonoEdit.centroResultados[i].docentes
                              ),
                    });
                    setCrSelect(temp);
                }
            }
        }
        init();
    }, [abonoEdit]);

    const handleRemoveCr = async (obj: ICrs) => {
        setCrSelect(crSelect.filter((e) => e !== obj));
    };

    const handleViewrCr = async (obj: ICrs, index: number) => {
        setCrEdit(obj);
        setCrEditIndex(index);
        setModalProf(true);
    };

    const CheckHorario = (e: string) => {
        const hora = e.split(":")[0];
        const minuto = e.split(":")[1];

        if (Number(hora) > 23 || Number(minuto) > 59) {
            return false;
        }
        if (!Number(hora + 1)) return false;
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (!Number(minuto + 1)) return false;

        return true;
    };

    const CheckHorarioFim = (e: string) => {
        const horaFim = e.split(":")[0];
        const minutoFim = e.split(":")[1];
        const horaIni = horaI.split(":")[0];
        const minutoIni = horaI.split(":")[1];

        if (Number(horaFim) > 23 || Number(minutoFim) > 59) {
            return false;
        }
        if (!Number(horaFim + 1)) return false;
        if (!Number(minutoFim + 1)) return false;

        if (Number(horaFim) < Number(horaIni)) return false;

        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (
            Number(horaFim) === Number(horaIni) &&
            Number(minutoFim) < Number(minutoIni)
        )
            return false;

        return true;
    };

    function CrList(cr: ICrs, index: number) {
        return (
            <div style={{ width: "100%", marginTop: 10 }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <label
                                style={{
                                    textAlign: "left",
                                    fontWeight: 600,
                                }}
                            >
                                {cr.cr[0].label}
                            </label>
                        </div>
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        handleViewrCr(cr, index);
                                    }}
                                    variant="link"
                                >
                                    <img src={View} />
                                </Button>
                                <Button
                                    onClick={() => {
                                        handleRemoveCr(cr);
                                    }}
                                    variant="link"
                                >
                                    <img
                                        src={CircleXMark}
                                        style={{ width: 16 }}
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const getProfsSelect = (index: number) => {
        const obj = crSelect[index].professores.filter((prof) => {
            return prof.isSelecionado;
        });

        return obj.map((prof) => {
            return {
                id: prof.docenteId,
            };
        });
    };

    const getCRSelect = async () => {
        const obj: any[] = [];

        for (let i = 0; i < crSelect.length; i++) {
            let temp: any = {};
            temp = {
                centroResultado: {
                    id: crSelect[i].cr[0].value,
                },
                todoProfessor: crSelect[i].isAll,
            };

            if (!crSelect[i].isAll) {
                const docentes = getProfsSelect(i);
                temp = {
                    ...temp,
                    docentes,
                };
            }

            obj.push(temp);
        }

        return obj;
    };

    const onSubmit = async () => {
        const cr = await getCRSelect();
        let abono: any = {
            nome: nomeFeriado,
            data: context ?? abonoEdit.data,
            centroResultados: cr,
            diaInteiro: isDia,
            campus: { id: campus[0].value },
        };

        if (!isDia) {
            abono = {
                ...abono,
                horaInicio: horaI,
                horaFim: horaF,
            };
        }
        if (abonoEdit) {
            const response = await axiosPutRequest(
                `docente/v1/calendarioabonoadministracoes/${abonoEdit.calendarioId}`,
                abono,
                acessToken,
                instance
            );

            if (response.status < 299) {
                onSuccess("Parâmetro cadastrado com sucesso!");
            } else {
                setErrorMessage("Erro ao cadastrar parâmetro!");
            }
        } else {
            const response = await axiosPostRequest(
                "docente/v1/calendarioabonoadministracoes",
                abono,
                acessToken,
                instance
            );

            if (response.status < 299) {
                onSuccess("Parâmetro cadastrado com sucesso!");
            } else {
                setErrorMessage("Erro ao cadastrar parâmetro!");
            }
        }
    };

    return modalProf || errorMessage ? (
        <div>
            <ModalProfessores
                campus={campus[0]?.value}
                open={modalProf}
                setCrSelect={setCrSelect}
                crSelect={crSelect}
                crEdit={crEdit}
                indexCrEdit={crEditIndex}
                onClose={() => {
                    setModalProf(false);
                    setCrEdit(undefined);
                    setCrEditIndex(-1);
                }}
            />
            {errorMessage ? DialogError : null}
        </div>
    ) : (
        <div>
            <Row>
                <Col>
                    <InputText
                        label="Nome do recesso"
                        floatLabel
                        value={nomeFeriado}
                        disabled
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <AutocompleteCombo
                        label="Selecione o campus"
                        options={campusAutoCompleteList}
                        selected={campus}
                        onChange={(e) => handleChangeCampus(e)}
                        placeholder="Selecione o campus"
                        extraOptions
                    />
                </Col>
            </Row>
            {campus.length > 0 && (
                <>
                    <Row>
                        <Col>
                            <div className="form-floating">
                                <InputMask
                                    mask="99:99"
                                    className="form-control"
                                    id="HorarioInicial"
                                    disabled={isDia}
                                    placeholder="00:00"
                                    style={{
                                        marginTop: 0,
                                        width: "100%",
                                        height: 50,
                                        color: isDia
                                            ? "black"
                                            : CheckHorario(horaI)
                                            ? "black"
                                            : "red",
                                        borderColor: isDia
                                            ? "black"
                                            : CheckHorario(horaI)
                                            ? "#787878"
                                            : "red",
                                    }}
                                    value={horaI}
                                    onBlur={() =>
                                        CheckHorario(horaI)
                                            ? null
                                            : setHoraI(``)
                                    }
                                    onChange={(e: any) =>
                                        setHoraI(e.target.value)
                                    }
                                    required
                                />
                                <label
                                    style={{
                                        color: isDia
                                            ? "black"
                                            : CheckHorario(horaI)
                                            ? "black"
                                            : "red",
                                        fontSize: 13,
                                    }}
                                    htmlFor="HorarioInicial"
                                >
                                    Hora inicio
                                </label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="form-floating">
                                <InputMask
                                    mask="99:99"
                                    disabled={isDia}
                                    className="form-control"
                                    id="HorarioFim"
                                    placeholder="00:00"
                                    style={{
                                        marginTop: 25,
                                        width: "100%",
                                        height: 50,
                                        color: isDia
                                            ? "black"
                                            : CheckHorarioFim(horaF)
                                            ? "black"
                                            : "red",
                                        borderColor: isDia
                                            ? "black"
                                            : CheckHorarioFim(horaF)
                                            ? "#787878"
                                            : "red",
                                    }}
                                    value={horaF}
                                    onBlur={() =>
                                        CheckHorarioFim(horaF)
                                            ? null
                                            : setHoraF(``)
                                    }
                                    onChange={(e: any) =>
                                        setHoraF(e.target.value)
                                    }
                                    required
                                />
                                <label
                                    style={{
                                        color: isDia
                                            ? "black"
                                            : CheckHorario(horaI)
                                            ? "black"
                                            : "red",
                                        fontSize: 13,
                                    }}
                                    htmlFor="HorarioInicial"
                                >
                                    Hora fim
                                </label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ marginTop: 25 }}>
                            <StyledFormCheck
                                type="checkbox"
                                checked={isDia}
                                label="O dia inteiro"
                                style={{ marginLeft: -11 }}
                                onChange={() => {
                                    setHoraI("");
                                    setHoraF("");
                                    setIsDia(!isDia);
                                }}
                            />
                        </Col>
                    </Row>
                    {crSelect.length > 0 && (
                        <div
                            style={{
                                marginTop: 20,
                                paddingTop: 10,
                                width: "100%",
                            }}
                        >
                            <Row style={{ marginLeft: 0 }}>
                                Professores adicionados:{" "}
                            </Row>
                        </div>
                    )}
                    {crSelect.map((cr, index) => {
                        return CrList(cr, index);
                    })}
                    <Row>
                        <Col
                            style={{ marginTop: 15, justifyContent: "center" }}
                        >
                            <StyledDefaultButtonLink
                                variant="link"
                                onClick={() => {
                                    setModalProf(true);
                                }}
                            >
                                <UserIcon
                                    style={{
                                        fill: "#8A0538",
                                        marginLeft: 40,
                                    }}
                                />
                                Selecionar professores
                            </StyledDefaultButtonLink>
                        </Col>
                    </Row>
                </>
            )}
            <StyledContainerButton>
                <BtnPrimary
                    disabled={
                        !(
                            (isDia &&
                                campus.length > 0 &&
                                crSelect.length > 0) ||
                            (campus.length > 0 &&
                                crSelect.length > 0 &&
                                CheckHorarioFim(horaF) &&
                                CheckHorario(horaI))
                        )
                    }
                    onClick={onSubmit}
                >
                    Salvar
                </BtnPrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <DefaultButtonLink onClick={() => setOpenDialogQuestion(true)}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
        </div>
    );
};

export default ModalAbonoLoteContent;
